<template>
  <div id="cover">
    <el-form :model="book" ref="bookForm" status-icon>
      <h2>本をつくる</h2>
      <el-form-item prop="title" label="タイトル" :rules="[{ required: true, message: 'タイトルを入力してください', trigger: 'blur' }]">
        <el-input placeholder="タイトル" v-model="book.title"></el-input>
      </el-form-item>
      <el-form-item label="タイトル（カナ）">
        <el-input placeholder="タイトル（カナ）" v-model="book.kana"></el-input>
      </el-form-item>
      <el-form-item label="概要">
        <el-input type="textarea" :rows="4" name="summary" placeholder="概要" v-model="book.summary"></el-input>
      </el-form-item>

      <h3>表紙</h3>
      <el-form-item>
        <el-radio v-model="book.is_image_only" label="1">画像のみ</el-radio>
        <el-radio v-model="book.is_image_only" label="0">エディタ</el-radio>
      </el-form-item>

      <el-form-item v-if="book.is_image_only==='1'" label="表紙画像">
        <i v-if="book.cover_image" class="el-icon-delete" @click="book.cover_image=''" ></i>
        <br>
        <el-upload v-if="!book.cover_image"
          class="upload-demo"
          drag
          action=""
          :show-file-list="false"
          :auto-upload="false"
          :thumbnail-mode="true"
          :on-change="handleChange">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">Drop jpg/png file here or <em>click to upload</em></div>
        </el-upload>
        <img v-if="book.cover_image" style="max-width:600px" :src="book.cover_image"/>
      </el-form-item>

      <label v-if="book.is_image_only==='0'" class="el-form-item__label" style="float:unset;">表紙</label>
      <el-form-item v-if="book.is_image_only==='0'">
        <editor v-model="book.cover_content" :init="coverEditorConfig"></editor>
      </el-form-item>

      <h3>フッター</h3>
      <el-form-item>
        <editor v-model="book.footer" :init="footerEditorConfig"></editor>
      </el-form-item>

      <el-form-item>
        <el-button size="medium" type="primary" @click="save('bookForm')">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import Editor from '@tinymce/tinymce-vue'
export default {
  name: 'new-cover',
  components: {
    'editor': Editor
  },
  data () {
    return {
      coverEditorConfig: {},
      footerEditorConfig: {},
      book: {
        title: '',
        kana: '',
        summary: '',
        cover_image: '',
        mime: '',
        is_image_only: '1',
        cover_content: '',
        footer: ''
      }
    }
  },
  created () {
    console.log('cover::created')
    this.coverEditorConfig = this.cloneObject(this.Constants.EDITOR_CONFIG)
    this.coverEditorConfig.file_picker_callback = this.Constants.EDITOR_CONFIG_FILEPICKER_CALLBACK
    this.footerEditorConfig = this.cloneObject(this.Constants.EDITOR_CONFIG)
    this.footerEditorConfig.file_picker_callback = this.Constants.EDITOR_CONFIG_FILEPICKER_CALLBACK
    this.footerEditorConfig.height = 80
  },
  computed: {
    isEdit () {
      return this.$route.params.id && !this.equalObject(this.book, this.selectBook)
    }
  },
  methods: {
    handleChange (file) {
      console.log(file)
      if (!(file.raw.type === 'image/jpeg' || file.raw.type === 'image/png')) {
        this.$message.error('Cover must be JPG or PNG format!')
        return false
      }

      var self = this
      var reader = new FileReader()
      reader.onload = (function (theFile) {
        return function (e) {
          console.log(theFile.type)
          console.log(e.target.result)
          self.book.cover_image = e.target.result
          self.book.mime = theFile.type
        }
      })(file.raw)
      reader.readAsDataURL(file.raw)
    },
    save (formName) {
      console.log(this.book)
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var self = this
          this.$store.dispatch('Books/insert', {'book': this.book}).then(function (response) {
            if (!response.result) {
              self.errorMessage(response.message)
            } else {
              self.successMessage(response.message)
              self.$router.push('/books')
            }
          })
        } else {
          console.log('error login')
          return false
        }
      })
    }
  }
}
</script>

<style>
.el-icon-delete:hover{
  cursor:pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/04-pages/NewCover.vue